<div class="container">
	<h3>System Log for {{api.user.organization_name}}</h3>
	<ng-template ngbModalContainer></ng-template>
	<table class="table-system-log">
		<thead>
			<tr>
				<th>Timestamp</th>
				<th>Environment</th>
				<th>Instance</th>
				<th>IP</th>
				<th>Requester</th>
				<th>Status</th>
				<th title="HTTP Method">HTTP</th>
				<th>Path</th>
				<th title="Query"><i class="icon-help-circled"></i></th>
				<th>Duration</th>
				<th>DB</th>
				<th>Analysis</th>
				<th title="Request size"><i class="icon-up-circled2"></i></th>
				<th title="Response size"><i class="icon-down-circled2"></i></th>
				<th class="request-message">Message</th>
				<th title="Exception"><i class="icon-attention-circled"></i></th>
			</tr>
		</thead>
		<tbody *ngFor="let log of pageLogs">
			<tr *ngIf="log.method !== null">
				<td>
					<span title="{{log.ts}}">
						<span>{{log.ts | datetime : "local"}}</span>
					</span>
				</td>
				<td><a (click)="applyFilter('environment_name', log.environment_name)"
						href="javascript:void(0)">{{log.environment_name}}</a></td>
				<td><a (click)="applyFilter('ec2_instance', log.ec2_instance)"
						href="javascript:void(0)">{{log.ec2_instance}}</a></td>
				<td><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
				<td><a (click)="applyRequesterFilter(log)" href="javascript:void(0)">{{ getRequester(log) }}</a></td>
				<td><a (click)="applyFilter('status_code', log.status_code)" href="javascript:void(0)"
						[style.color]="log.status_code | httpstatuscolor">{{log.status_code}}</a></td>
				<td><a (click)="applyFilter('http_method', log.method)" href="javascript:void(0)">{{log.method}}</a></td>
				<td><a (click)="applyFilter('path', log.path)" href="javascript:void(0)">{{log.path}}</a></td>
				<td><i *ngIf="log.query" title="{{log.query}}" class="icon-help-circled"></i></td>
				<td><span [class.log-long-response]="log.response_time_us > 200000">{{log.response_time_us / 1000.0 | number :
						"1.0-0"}}</span>ms
				</td>
				<td>{{log.db_time_us ? (log.db_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
				<td>{{log.analysis_time_us ? (log.analysis_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
				<td>{{log.request_size | filesize}}</td>
				<td>{{log.response_size | filesize:2}}</td>
				<td class="request-message">{{log.message}}</td>
				<td><i *ngIf="log.exception && log.exception !== 'true'" (click)="showException(log)" title="{{log.exception}}"
						class="icon-attention-circled clickable"></i></td>
			</tr>
			<tr *ngIf="(log.method === null) && (log.remote_ip !== null)">
				<td>
					<span title="{{log.ts}}">
						<span>{{log.ts | datetime : "local"}}</span>
					</span>
				</td>
				<td><a (click)="applyFilter('environment_name', log.environment_name)"
						href="javascript:void(0)">{{log.environment_name}}</a></td>
				<td><a (click)="applyFilter('ec2_instance', log.ec2_instance)"
						href="javascript:void(0)">{{log.ec2_instance}}</a></td>
				<td><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
				<td><a (click)="applyRequesterFilter(log)" href="javascript:void(0)">{{ getRequester(log) }}</a></td>
				<td colspan="10" class="system-message" [class.log-error]="log.exception">{{log.message}}</td>
				<td><i *ngIf="log.exception && log.exception !== 'true'" (click)="showException(log)" title="{{log.exception}}"
						class="icon-attention-circled clickable"></i></td>
			</tr>
			<tr *ngIf="(log.method === null) && (log.remote_ip === null) && (log.response_time_us !== null)">
				<td>
					<span title="{{log.ts}}">
						<span>{{log.ts | datetime : "local"}}</span>
					</span>
				</td>
				<td><a (click)="applyFilter('environment_name', log.environment_name)"
						href="javascript:void(0)">{{log.environment_name}}</a></td>
				<td><a (click)="applyFilter('ec2_instance', log.ec2_instance)"
						href="javascript:void(0)">{{log.ec2_instance}}</a></td>
				<td colspan="6" class="system-message" [class.log-import-message]="log.type === 1"
					[class.log-error]="log.exception">{{log.message}}</td>
				<td colspan="6"><span [class.log-long-response]="log.response_time_us > 5000000">{{log.response_time_us / 1000.0
						| number : "1.0-0"}}</span>ms
				</td>
				<td><i *ngIf="log.exception && log.exception !== 'true'" (click)="showException(log)" title="{{log.exception}}"
						class="icon-attention-circled clickable"></i></td>
			</tr>
			<tr *ngIf="(log.method === null) && (log.remote_ip === null) && (log.response_time_us === null)">
				<td>
					<span title="{{log.ts}}">
						<span>{{log.ts | datetime : "local"}}</span>
					</span>
				</td>
				<td><a (click)="applyFilter('environment_name', log.environment_name)"
						href="javascript:void(0)">{{log.environment_name}}</a></td>
				<td><a (click)="applyFilter('ec2_instance', log.ec2_instance)"
						href="javascript:void(0)">{{log.ec2_instance}}</a></td>
				<td colspan="12" class="system-message" [class.log-import-message]="log.type === 1"
					[class.log-error]="log.exception">{{log.message}}</td>
				<td><i *ngIf="log.exception && log.exception !== 'true'" (click)="showException(log)" title="{{log.exception}}"
						class="icon-attention-circled clickable"></i></td>
			</tr>
		</tbody>
	</table>
	<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage"
		(pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true" [rotate]="true"></ngb-pagination>
	<div class="row mb-4">
		<div *ngIf="filters.environment_name" class="col-sm-6 col-md-4">
			Environment: {{filters.environment_name}}
			<i (click)="removeFilter('environment_name')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.ec2_instance" class="col-sm-6 col-md-4">
			Instance: {{filters.ec2_instance}}
			<i (click)="removeFilter('ec2_instance')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.remote_ip" class="col-sm-6 col-md-4">
			IP: {{filters.remote_ip}}
			<i (click)="removeFilter('remote_ip')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.status_code" class="col-sm-6 col-md-4">
			Status: {{filters.status_code}}
			<i (click)="removeFilter('status_code')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.http_method" class="col-sm-6 col-md-4">
			Method: {{filters.http_method}}
			<i (click)="removeFilter('http_method')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.path" class="col-sm-6 col-md-4">
			Path: {{filters.path}}
			<i (click)="removeFilter('path')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.user?.email" class="col-sm-6 col-md-6">
			User: {{filters.user?.email}}
			<i (click)="removeFilter('user')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.device?.serial" class="col-sm-6 col-md-6">
			Device: {{filters.device?.serial}}
			<i (click)="removeFilter('device')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="filters.asset?.name" class="col-sm-6 col-md-6">
			Asset: {{filters.asset?.name}}
			<i (click)="removeFilter('asset')" class="icon-minus-circled clickable"></i>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_myself"
					(ngModelChange)="refreshTable()"> Ignore my own requests</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_users"
					(ngModelChange)="refreshTable()"> Ignore users</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_devices"
					(ngModelChange)="refreshTable()"> Ignore devices</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_system"
					(ngModelChange)="refreshTable()"> Ignore system messages</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_long_responses"
					(ngModelChange)="refreshTable()"> Only long responses ( &gt;=1000ms)</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_exceptions"
					(ngModelChange)="refreshTable()"> Only exceptions</label></div>
	</div>
	<div class="row">
		<div class="col-sm-2">
			<button (click)="ResetFilters()" class="btn btn-info">Reset</button>
		</div>
	</div>
</div>



<ng-template #exceptionModal let-c="close">
	<div class="modal-header">
		<h4 class="modal-title">Exception detail</h4>
		<button type="button" class="close" aria-label="Close" (click)="c()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<h3>Exception</h3>
		<pre>{{selectedException | json}}</pre>
		<div *ngIf="selectedExceptionStack">
			<h3>Stack</h3>
			<pre>{{selectedExceptionStack}}</pre>
		</div>
		<div *ngIf="selectedExceptionSubStack">
			<h3>Detail stack</h3>
			<pre>{{selectedExceptionSubStack}}</pre>
		</div>
	</div>
</ng-template>